/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiTuneIn } from './TuneIn';
import { ApiBrandColor } from './BrandColor';
import { ApiAbbreviatedTalent } from './AbbreviatedTalent';

export interface ShowRequest {

    id?: string;

    /**
     * Name of the show
     */
    name?: string;

    /**
     * The titles specified on the content in this show (productions, podcasts, VODs) will be shown in the app
     */
    use_titles?: boolean;

    /**
     * URL-friendly name for the show
     */
    slug?: string;

    tune_ins?: ApiTuneIn[];

    logo1?: string;

    logo1_landscape?: string;

    logo_square?: string;

    /**
     * Brand color for the show
     */
    brand_color?: ApiBrandColor;

    /**
     * Description of the show
     */
    description?: string;

    /**
     * Talent involved with the show
     */
    hosts?: ApiAbbreviatedTalent;

    /**
     * Talent involved with the show
     */
    guest_hosts?: ApiAbbreviatedTalent;

    /**
     * The default tab of an individual show in app
     */
    default_tab?: string;

    logo?: string;

    web_banner_landing_page?: string;

    web_header_image?: string;

    tv_header_image?: string;

    logo2?: string;

    logo2_landscape?: string;

    /**
     * URL for landscape thumbnail 1
     */
    thumbnail_landscape1?: string;

    /**
     * URL for landscape thumbnail 2
     */
    thumbnail_landscape2?: string;

    /**
     * URL for portrait thumbnail 2
     */
    logo_header_collapsed?: string;

    /**
     * Whether this show requires TYT membership to watch
     */
    is_premium?: boolean;

    /**
     * Whether clips are enabled for this show
     */
    enable_clips?: boolean;

    /**
     * Whether Video On Demand (VOD) is enabled for this show
     */
    enable_vod?: boolean;

    /**
     * Whether podcasting is available for this show
     */
    enable_podcasting?: boolean;

    /**
     * True if this show can be broadcast live
     */
    enable_live_video?: boolean;

    /**
     * True if this show enables text articles
     */
    enable_text_articles?: boolean;

    /**
     * The YouTube channel URL for this show
     */
    youtube_url?: string;

    /**
     * The website URL for this show (optional)
     */
    website_url?: string;

    /**
     * The handle of the official Twitter account for this show
     */
    twitter_handle?: string;

    /**
     * The handle of the official Instagram account for this show
     */
    instagram_handle?: string;

    /**
     * The handle of the official Snapchat account for this show
     */
    snapchat_handle?: string;

    /**
     * The handle of the official Facebook account for this show
     */
    facebook_url?: string;

    /**
     * Is the show no longer being produced?
     */
    is_past_show?: boolean;

    /**
     * Is the show a partner show?
     */
    is_partner_show?: boolean;

    /**
     * Can the show be followed by users?
     */
    is_followable?: boolean;

    live_time?: string;

    publishing_note?: string;

    archive_policy?: string;

}

@Model('Show')
export class ApiShow extends BaseModel implements ShowRequest {

    
    
    id: string;

    /**
     * Name of the show
     */
    
    
    name: string;

    /**
     * The titles specified on the content in this show (productions, podcasts, VODs) will be shown in the app
     */
    
    
    use_titles: boolean;

    /**
     * URL-friendly name for the show
     */
    
    
    slug: string;

    @Type('ApiTuneIn')
    @Expand()
    tune_ins: ApiTuneIn[];

    
    
    logo1: string;

    
    
    logo1_landscape: string;

    
    
    logo_square: string;

    /**
     * Brand color for the show
     */
    @Type('ApiBrandColor')
    @Expand()
    brand_color: ApiBrandColor;

    /**
     * Description of the show
     */
    
    
    description: string;

    /**
     * Talent involved with the show
     */
    @Type('ApiAbbreviatedTalent')
    @Expand()
    hosts: ApiAbbreviatedTalent;

    /**
     * Talent involved with the show
     */
    @Type('ApiAbbreviatedTalent')
    @Expand()
    guest_hosts: ApiAbbreviatedTalent;

    /**
     * The default tab of an individual show in app
     */
    
    
    default_tab: string;

    
    
    logo: string;

    
    
    web_banner_landing_page: string;

    
    
    web_header_image: string;

    
    
    tv_header_image: string;

    
    
    logo2: string;

    
    
    logo2_landscape: string;

    /**
     * URL for landscape thumbnail 1
     */
    
    
    thumbnail_landscape1: string;

    /**
     * URL for landscape thumbnail 2
     */
    
    
    thumbnail_landscape2: string;

    /**
     * URL for portrait thumbnail 2
     */
    
    
    logo_header_collapsed: string;

    /**
     * Whether this show requires TYT membership to watch
     */
    
    
    is_premium: boolean;

    /**
     * Whether clips are enabled for this show
     */
    
    
    enable_clips: boolean;

    /**
     * Whether Video On Demand (VOD) is enabled for this show
     */
    
    
    enable_vod: boolean;

    /**
     * Whether podcasting is available for this show
     */
    
    
    enable_podcasting: boolean;

    /**
     * True if this show can be broadcast live
     */
    
    
    enable_live_video: boolean;

    /**
     * True if this show enables text articles
     */
    
    
    enable_text_articles: boolean;

    /**
     * The YouTube channel URL for this show
     */
    
    
    youtube_url: string;

    /**
     * The website URL for this show (optional)
     */
    
    
    website_url: string;

    /**
     * The handle of the official Twitter account for this show
     */
    
    
    twitter_handle: string;

    /**
     * The handle of the official Instagram account for this show
     */
    
    
    instagram_handle: string;

    /**
     * The handle of the official Snapchat account for this show
     */
    
    
    snapchat_handle: string;

    /**
     * The handle of the official Facebook account for this show
     */
    
    
    facebook_url: string;

    /**
     * Is the show no longer being produced?
     */
    
    
    is_past_show: boolean;

    /**
     * Is the show a partner show?
     */
    
    
    is_partner_show: boolean;

    /**
     * Can the show be followed by users?
     */
    
    
    is_followable: boolean;

    
    
    live_time: string;

    
    
    publishing_note: string;

    
    
    archive_policy: string;

}
